import React from "react";

const ChampionContext = React.createContext({
  champions: [],
  loading: true,
});

export default ChampionContext;
